import { Component } from '@angular/core';

@Component({
  selector: 'app-no-url-found',
  templateUrl: './no-url-found.component.html',
  styleUrls: ['./no-url-found.component.scss']
})
export class NoUrlFoundComponent {}
